
import React from 'react';
import ReactMarkdown from 'react-markdown';

interface CandidateGenerationRendererProps {
  content: string;
  isProduction: boolean;
}

const CandidateGenerationRenderer: React.FC<CandidateGenerationRendererProps> = ({ 
  content, 
  isProduction 
}) => {
  // Process the content to fix image paths
  const processedContent = content.replace(
    /!\[([^\]]*)\]\((\/images\/|\/assets\/|\/|)([^)]+)\)/g, 
    (match, altText, pathPrefix, imagePath) => {
      // Use the correct path based on environment
      const basePath = isProduction ? '/assets' : '/images';
      const filename = imagePath.split('/').pop(); // Extract just the filename, ignoring any directory structure
      return `![${altText}](${basePath}/${filename})`;
    }
  );

  console.log("CandidateGenerationRenderer - Processing markdown with image paths:", {
    originalLength: content.length,
    processedLength: processedContent.length,
    isProduction,
    hasImageReferences: content.includes('!['),
    transformedReferences: processedContent.includes('/assets/') || processedContent.includes('/images/')
  });

  return (
    <div className="candidate-generation-article">
      <ReactMarkdown>{processedContent}</ReactMarkdown>
    </div>
  );
};

export default CandidateGenerationRenderer;
